export default "<app-main-layout\r\n></app-main-layout>\r\n";